var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 6.33301C15.5617 6.33301 16.625 5.26968 16.625 3.95801C16.625 2.64633 15.5617 1.58301 14.25 1.58301C12.9383 1.58301 11.875 2.64633 11.875 3.95801C11.875 5.26968 12.9383 6.33301 14.25 6.33301Z",
    stroke: "#1A1B32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 11.875C6.06168 11.875 7.125 10.8117 7.125 9.5C7.125 8.18832 6.06168 7.125 4.75 7.125C3.43832 7.125 2.375 8.18832 2.375 9.5C2.375 10.8117 3.43832 11.875 4.75 11.875Z",
    stroke: "#1A1B32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 17.417C15.5617 17.417 16.625 16.3537 16.625 15.042C16.625 13.7303 15.5617 12.667 14.25 12.667C12.9383 12.667 11.875 13.7303 11.875 15.042C11.875 16.3537 12.9383 17.417 14.25 17.417Z",
    stroke: "#1A1B32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.80078 10.6953L12.2079 13.8461",
    stroke: "#1A1B32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1999 5.15332L6.80078 8.30415",
    stroke: "#1A1B32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare2);
export default __webpack_public_path__ + "static/media/share2.c8466619db67c2701e5e56a14c6618e9.svg";
export { ForwardRef as ReactComponent };